/* eslint-disable jsx-a11y/anchor-is-valid */

import {KTIcon} from '../../../../_metronic/helpers'

type Props = {
  id: number
  selectItem: (id: number) => void
}

const ActionCell = ({id, selectItem}: Props) => {
  return (
    <div className='text-end'>
      <a
        href='#'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_1'
        onClick={() => selectItem(id)}
      >
        <KTIcon iconName='pencil' className='fs-3' />
      </a>
      <a
        href='#'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_2'
        onClick={() => selectItem(id)}
      >
        <KTIcon iconName='trash' className='fs-3 text-danger' />
      </a>
    </div>
  )
}

export default ActionCell
